<template>
    <article class="member-signup" data-app>
        <div class="signed-in" v-if="displayLogout">
            <section>
                <h2>{{greeting}} {{localName}}</h2>
                <div class="mb-3">
                    Nu Skin ID:
                    <br />
                    <strong>{{userId}}</strong>
                </div>
                <hr class="loginline" />
                <div class="mt-3 mb-3">{{logoutOrContinue}} {{localName}}?</div>
                <input
                    class="primary-hit fluid mb-2"
                    type="submit"
                    @click="logoutAndResume"
                    :value="logoutBtnText"
                />
                <input
                    class="secondary-hit fluid"
                    type="submit"
                    @click="continueUsage"
                    :value="continueBtnText"
                />
            </section>
        </div>
        <div v-else>
            <section>
                <h2 style="text-transform: uppercase;">{{pageTitle}}</h2>
                <div class="subtitle">{{welcomeText}}</div>
            </section>
            <ns-toast
                success
                icon
                :delay="delay"
                :show-trigger="showResetSuccessToast"
                :message="resetFormSuccessMsg"
            />

            <section v-if="showOktaWidget">
                <okta-login
                    :updateValueCallback="updateValueFromOkta"
                    :gigyaLogin="handleLogin"
                    :loginerror="loginerror"
                    :setUsername="setUsername"
                    :setPassword="setPassword"
                    :toggleWidget="toggleWidget"/>
            </section>
            <section v-else>
                <form class="v-form" @submit.prevent="handleLogin">
                    <div
                        class="v-input v-text-field v-input--is-label-active v-input--is-dirty theme--light flex-column"
                    >
                        <div class="v-input__control">
                            <div class="v-input__slot">
                                <div class="v-text-field__slot">
                                    <label
                                        aria-hidden="true"
                                        class="v-label v-label--active theme--light"
                                        style="left: 0px; right: auto; position: absolute;"
                                    >{{usernameLabel}}</label>
                                    <input
                                        :aria-label="usernameLabel"
                                        name="username"
                                        type="text"
                                        formnovalidate="formnovalidate"
                                        autocomplete="off"
                                    />
                                </div>
                            </div>
                            <div class="v-text-field__details">
                                <div class="v-messages theme--light">
                                    <div class="v-messages__wrapper"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="v-input v-text-field theme--light flex-column">
                        <div class="v-input__control">
                            <div class="v-input__slot">
                                <div class="v-text-field__slot">
                                    <label
                                        aria-hidden="true"
                                        class="v-label theme--light"
                                        style="left: 0px; right: auto; position: absolute;"
                                    >{{passwordLabel}}</label>
                                    <input
                                        :aria-label="passwordLabel"
                                        name="password"
                                        type="password"
                                        formnovalidate="formnovalidate"
                                        autocomplete="off"
                                    />
                                    <div class="v-text-field__suffix" id="showPassDiv">{{hidePasswordText}}</div>
                                </div>
                                <div>
                                </div>
                                <div class="v-input__append-inner">
                                    <div class="v-input__icon v-input__icon--append" @click="togglePassword">
                                        <i
                                            aria-hidden="true"
                                            class="v-icon v-icon--link material-icons theme--light"
                                        >none</i>
                                    </div>
                                </div>
                            </div>
                            <div class="v-text-field__details">
                                <div class="v-messages theme--light">
                                    <div class="v-messages__wrapper"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="forgot-pass-link">
                        <a id="forgotPasswordAnchor" href="#" @click="forgotPasswordLink">{{forgotPassLinkText}}</a>
                    </div>

                    <div v-show="loginerror" id="loginFormError" class="style-scope ns-login">
                        <p class="style-scope ns-login">{{loginFormErrorMsg}}</p>
                    </div>

                    <div class="captcha-styles">
                        <vue-recaptcha
                            ref="invisibleRecaptcha"
                            @verify="onVerify"
                            @expired="onExpired"
                            v-if="captchaNeeded"
                            sitekey="6LcoqA8aAAAAAH2OfcVWNuJKIE0HRs7U_TQMpzgh"
                            :loadRecaptchaScript="true"/>
                    </div>

                    <input class="primary-hit fluid"  type="submit" :disabled="loginDisabled" :value="logInBtnText" />
                    <p v-if="showError" class="unknown-error v-messages error--text">{{t.unknownError}}</p>
                </form>
            </section>

            <div id="signupMarketing" v-if="!hideSignup">
                <section>
                    <hr class="loginline" />
                    <h4 class="center" style="padding-top: 15px;">{{signUpMarketingTitle}}</h4>
                </section>
                <section>
                    <button class="secondary-hit fluid login-button" @click="handleSignUp">{{signUpBtnText}}</button>
                </section>
                <div style="margin-top: -10px;">
                    <!-- eslint-disable vue/no-v-html -->
                    <p class="center" v-html="signUpMarketingTagline"></p>
                    <!-- eslint-enable vue/no-v-html -->
                    <ul class="benefits">
                        <li v-for="(benefits, index) in marketingBenefits" :key="index">{{ benefits.text }}</li>
                    </ul>
                </div>
            </div>
        </div>
        <loader v-show="processing" />
    </article>
</template>

<script>
import {events, ConfigService, cookieUtil} from '@nuskin/ns-util';
import {
    AuthenticationService,
    UserService,
    AccountManager,
    newAccount
} from '@nuskin/ns-account';
import Loader from '../components/Loader';
import OktaLogin from '../components/OktaLogin';
import {NsToast} from '@nuskin/design-components';
import axios from 'axios';
import VueRecaptcha from 'vue-recaptcha';

export default {
    name: 'Login',
    components: {
        Loader,
        NsToast,
        VueRecaptcha,
        OktaLogin
    },
    props: {
    /* Already Logged in */
        greeting: {
            type: String,
            default: 'Hi'
        },
        logoutOrContinue: {
            type: String,
            default: 'Would you like to logout or continue as '
        },
        logoutBtnText: {
            type: String,
            default: 'Logout'
        },
        continueBtnText: {
            type: String,
            default: 'Continue'
        },

        /**
     * Where to go after a successful login.
     */
        destinationUrl: {
            type: String,
            default: window.redirectUrl
        },
        /**
     * The text displayed on the button in the forgot password view
     */
        loginTokenBtnText: {
            type: String,
            default: 'Generate login token'
        },
        /**
     * The text displayed after the password recovery email has been successfully sent
     */
        loginTokenConfirmText: {
            type: String,
            default:
        '<p>If your username exists in our system, we have sent reset password instructions to the email provided.</p><br><p>Please note this is a time sensitive email.</p>'
        },
        /**
     * The Title displayed after the password recovery email has been successfully sent
     */
        loginTokenConfirmTitle: {
            type: String,
            default: 'Thank You!'
        },
        /**
     * Error message that appears if the input on the forgot password view is invalid
     */
        loginTokenError: {
            type: String,
            default: 'A username or email address is required'
        },
        /**
     * The label text for the password expired text label 1
     */
        passExpirationLabel_1: {
            type: String,
            default: 'OOPS!'
        },
        /**
     * The label text for the password expired text label 2
     */
        passExpirationLabel_2: {
            type: String,
            default: 'Sorry.'
        },
        /**
     * The label text for the password expired text label 3
     */
        passExpirationLabel_3: {
            type: String,
            default: 'Your password reset link has expired.'
        },

        /**
     * Message that appears in the toast message after a successful password reset
     */
        resetFormSuccessMsg: {
            type: String,
            default: 'Success! New password created.'
        },

        /**
     * The text for the link that takes the user from the main login view to the forgot password view
     */
        forgotPassLinkText: {
            type: String,
            default: 'Forgot Password'
        },
        /**
     * The tagline text (just under the title) for the forgot password view
     */
        forgotPassTagline: {
            type: String,
            default:
        'Enter your username below and we will send you a link to reset your password.'
        },
        /**
     * The title text for the forgot password view
     */
        forgotPassTitle: {
            type: String,
            default: 'Forgot your password?'
        },

        /**
     * The label text for the forgot password input on the forgot password view
     */
        loginTokenLabel: {
            type: String,
            default: 'Username (Email Address)'
        },
        /**
     * The text for the link that takes the user from the main login view to the forgot password view
     */
        loginTokenLinkText: {
            type: String,
            default: 'Forgot Password'
        },
        /**
     * The tagline text (just under the title) for the forgot password view
     */
        loginTokenTagline: {
            type: String,
            default:
        'Enter your username below and we will send you an email containing a link for a one time login'
        },
        /**
     * The title text for the forgot password view
     */
        loginTokenTitle: {
            type: String,
            default: 'Alternative Login'
        },
        /**
     * Hides the signup button and the marketing below it
     */
        hideSignup: {
            type: Boolean,
            default: window.loginPageConfig.hideSignup
        },
        /**
     * The text displayed on the button in the main login view that submits the login form
     */
        logInBtnText: {
            type: String,
            default: 'Sign In'
        },
        /**
     * The error message that gets displayed when the credentials are incorrect
     */
        loginFormErrorMsg: {
            type: String,
            default: 'Sorry there was a problem getting you logged in.'
        },
        /**
     * The error message that is displayed when the password field is invalid
     */
        loginPasswordError: {
            type: String,
            default: 'Oops! The password field is looking pretty empty'
        },
        /**
     * The error message that is displayed when the username field is invalid (currently when blank)
     */
        loginUsernameError: {
            type: String,
            default: 'Wait, who are you?'
        },
        /**
     * The title text for the main login view
     */
        pageTitle: {
            type: String,
            default: 'Sign In'
        },
        /**
     * The label text for the password input on the main login view
     */
        passwordLabel: {
            type: String,
            default: 'Password'
        },
        /**
     * The text displayed on the button in the main login view that redirects the user to the sign up flow
     */
        signUpBtnText: {
            type: String,
            default: 'Sign Up'
        },
        /**
     * The text displayed on the main login view for the first bullet point under the benefits section
     */
        signUpMarketingBenefits1: {
            type: String,
            default: 'Save time! Keep your information on file for fast checkout.'
        },
        /**
     * The text displayed on the main login view for the second bullet point under the benefits section
     */
        signUpMarketingBenefits2: {
            type: String,
            default: 'Easily track and manage your orders.'
        },
        /**
     * The text displayed on the main login view for the third bullet point under the benefits section
     */
        signUpMarketingBenefits3: {
            type: String,
            default: 'Learn about your favorite products.'
        },
        /**
     * The text displayed on the main login view for the fourth bullet point under the benefits section
     */
        signUpMarketingBenefits4: {
            type: String,
            default: 'Get exclusive product news and recommendations.'
        },
        /**
     * The text that shows up just under the sign up button on the main login view
     */
        signUpMarketingTagline: {
            type: String,
            default: 'Create a Nu Skin account with <b>great benefits</b>.'
        },
        /**
     * The text that shows up just above the sign up button on the main login view
     */
        signUpMarketingTitle: {
            type: String,
            default: 'New to Nu Skin?'
        },
        /**
     * The label text for the username input on the main login view
     */
        usernameLabel: {
            type: String,
            default: ''
        },
        /**
     * The tagline text (just under the page title) for the main login view
     */
        welcomeText: {
            type: String,
            default: ''
        },
        /**
     * specifies which gigya api key to use
     */
        devMode: {
            type: Boolean,
            default: false
        },
        /**
     * The password Show text
     */
        passwordShowText: {
            type: String,
            default: 'Show'
        },
        passwordHideText: {
            type: String,
            default: 'Hide'
        },
        disallowedPrefix: {
            type: String,
            default: 'You are not allowed to login for this market.'
        }
    },
    data() {
        return {
            showOktaWidget: false,
            valid: true,
            showResetSuccessToast: false,
            loginerror: false,
            loginDisabled: false,
            password: '',
            username: '',
            captchaToken: '',
            captchaNeeded: false,
            marketingBenefits: [],
            processing: false,
            hideSignin: false,
            hidePasswordText: '',
            eidRequired: false,
            useLogoutPrompt: false,
            isLoggedIn: UserService.isLoggedIn(),
            userObjectExists: UserService.getUser() != null ? true : false,
            isUsingGigyaAuthentication: false
        };
    },
    watch: {
        loginerror(val) {
            if (val === true && !this.$features['cx107-login-cutover']) {
                // fallback to Gigya screen upon first failure from Okta
                // this ensures that we use Recaptcha on multiple failed login attempts
                this.showOktaWidget = false;
            }
        }
    },
    computed: {
        localName() {
            return UserService.getUser().localName;
        },
        userId() {
            return UserService.getUser().id;
        },
        displayLogout() {
            return this.isLoggedIn && this.useLogoutPrompt && this.userObjectExists;
        }
    },
    async beforeMount() {
        await this.$features.$waitForLoad();
        /**
         * FF for okta login widget enabled
         */
        const showOktaLoginFFEnabled = this.$features['cx107_189'] || this.$features['cx107-login-cutover'] || cookieUtil.getCookie('oktaPilotRun');

        /**
         * Okta login widget enabled for SAML login
         */
        const oktaEnabledForSAML = this.$features['cx107-435-use-okta-for-saml-login'] || !window.loginPageConfig.isSAML;

        this.showOktaWidget = showOktaLoginFFEnabled && oktaEnabledForSAML;
    },
    async mounted() {
        // TODO remove feature toggle
        if (this.$features['cx13_6504_post_conversion_analytics']) {
            if (
                typeof this.destinationUrl != 'undefined' &&
        this.destinationUrl.length > 0
            ) {
                if (this.destinationUrl.indexOf('.mysite.html') >= 0) {
                    this.hideSignup = true;
                    // TODO: in future will need a queryParam for conversionTo property
                } else if (this.destinationUrl.indexOf('convert-account.html') >= 0) {
                    events.publish('Account Type Conversion', {
                        conversionAction: 'signInLoaded',
                        conversionTo: 'Member'
                    });
                }
            }
        } else {
            if (
                typeof this.destinationUrl != 'undefined' &&
        this.destinationUrl.length > 0 &&
        this.destinationUrl.indexOf('.mysite.html') > 0
            ) {
                this.hideSignup = true;
            }
        }
        if (window.location.href.includes('pwrt')) {
            this.$router.push({
                name: 'reset-password'
            });
        }
        if (
            typeof window.loginPageConfig.useLogoutPrompt != 'undefined' &&
      window.loginPageConfig.useLogoutPrompt
        ) {
            this.useLogoutPrompt = true;
        }
        if (typeof window.passEid != 'undefined' && window.passEid.length > 0) {
            this.eidRequired = true;
        }
        if (window.location.href.includes('showResetSuccess')) {
            this.showResetSuccessToast = !this.showResetSuccessToast;
        }

        this._setTranslations();
        // Subscribe to gigya login events
        events.subscribe(events.authentication.ERROR_TOO_MANY_LOGIN_ATTEMPTS, (message) => {
            this.processing = false;
            this.valid = true;
            this.loginDisabled = true;
            this.captchaNeeded = true;
        });
        events.subscribe(events.authentication.INVALID_LOGIN_ATTEMPT, (message) => {
            this.processing = false;
            this.valid = true;
            this.loginerror = true;
            this.isUsingGigyaAuthentication = false;
        });
        events.subscribe(events.authentication.LOGIN_MAX_ATTEMPTS, (message) => {
            this.processing = false;
            this.valid = false;
            this.loginerror = true;
        });
        events.subscribe(events.authentication.LOGIN_LOCKED, (message) => {
            this.processing = false;
            this.valid = false;
            this.loginerror = true;
        });
        events.subscribe(events.authentication.RESET_PASSWORD_ERROR, (message) => {
            this.processing = false;
            this.valid = false;
            this.loginerror = true;
        });
        events.subscribe(
            events.authentication.RESET_PASSWORD_SUCCESS,
            (message) => {
                //  this._handleResetSuccess('reset', message);
            }
        );
        events.subscribe(events.authentication.LOGIN_COMPLETE, async (message) => {
            await this._callJitMigrationEndPoint();
            this.processing = false;
            this.valid = true;
            this._completeLogin();
        });
        events.subscribe(events.authentication.PNP_CHECK, async (message) => {
            await this._callJitMigrationEndPoint();
        });

        if (!this.showOktaWidget) {
            this.$el.querySelector('[name="username"]').focus();
        }
    },
    methods: {
        updateValueFromOkta: function(property, value) {
            this[property] = value;
        },
        onVerify: function(response) {
            this.captchaToken = response;
            this.loginDisabled = false;
        },
        onExpired: function() {
        },
        continueUsage() {
            const self = this;
            if (this.isLoggedIn) {
                AccountManager.simplePing().done(function(response) {
                    self._completeLogin();
                });
            }
        },
        logoutAndResume() {
            AuthenticationService.logout();
            events.publish(events.authentication.LOGOUT_LEGACY);
            events.publish(events.authentication.LOGOUT);
            newAccount.BuyerCookieService.resetBuyerCookie();
            UserService.setLoggedIn(false);
            this.isLoggedIn = false;
            this.userObjectExists = false;
            /** Reload Page after making sure logout was successful **/
        },
        togglePassword(event) {
            if (this.hidePasswordText == this.passwordHideText) {
                this.hidePasswordText = this.passwordShowText;
                document.querySelector('[name="password"]').type = 'password';
            } else {
                this.hidePasswordText = this.passwordHideText;
                document.querySelector('[name="password"]').type = 'text';
            }
        },
        forgotPasswordLink() {
            this.$router.push({
                name: 'forgot-password'
            });
        },
        showPassword() {
            if (this.type === 'password') {
                this.$.input.type = 'text';
            }
        },
        handleSignUp() {
            events.publish(events.authentication.REQUEST_FOR_SIGNUP, ['From login']);
        },
        handleLogin() {
            this.username = (document.querySelector('[name="username"]') || {}).value;
            this.password = (document.querySelector('[name="password"]') || {}).value;
            if (this.username && this.password && this.username != '' && this.password != '') {
                this.processing = true;
                this.valid = false;
                this.isUsingGigyaAuthentication = true;
                if (this.captchaNeeded) {
                    AuthenticationService.login(this.username, this.password, this.devMode, this.captchaToken);
                } else {
                    AuthenticationService.login(this.username, this.password, this.devMode);
                }
            }
        },
        setUsername(username) {
            this.username = username;
        },
        setPassword(password) {
            this.password = password;
        },
        toggleWidget(flag) {
            this.showOktaWidget = flag;
        },
        async _callJitMigrationEndPoint() {
            //  jit migrate only if user is gigya authenticated
            if (this.$features['cx107_19'] && this.isUsingGigyaAuthentication) {
                // jit migration endpoint
                const user = UserService.getUser();
                const payload = {
                    username: this.username,
                    password: this.password,
                    email: user.email,
                    sapID: user.id,
                    eventType: 'USER_WEB_LOGIN',
                    eventSource: 'LOGIN_VUE_COMPONENT'
                };
                const headers = {
                    Authorization: 'JWT ' + user.eid,
                    client_id: this._getClientId()
                };

                try {
                    await axios.post(process.env.VUE_APP_JIT_MIGRATION_ENDPOINT, payload, {headers});
                } catch (err) {
                    console.error(err);
                }
            }
            this.isUsingGigyaAuthentication = false;
        },
        _decodeUrl(_urlParam) {
            return _urlParam.replace('_hb_', '#');
        },
        _completeLogin() {
            this.loginerror = false;
            if (
                typeof this.destinationUrl != 'undefined' &&
        this.destinationUrl.length > 0
            ) {
                this.destinationUrl = this._decodeUrl(this.destinationUrl);
            } else {
                this.destinationUrl = document.referrer;
            }
            // If and eid is needed, add query params to end of dest url from user service
            if (this.eidRequired) {
                const eid = UserService.getUser().eid;
                window.location =
          this.destinationUrl +
          '?accountId=' +
          UserService.getUser().id +
          '&eid=' +
          eid;
            } else {
                window.location = this.destinationUrl;
            }
        },
        _setTranslations() {
            const loginTranslations = window.loginTranslations;
            this.greeting = loginTranslations.greeting || this.greeting;
            this.logoutOrContinue =
        loginTranslations.logoutOrContinue || this.logoutOrContinue;
            this.logoutBtnText =
        loginTranslations.logoutBtnText || this.logoutBtnText;
            this.continueBtnText =
        loginTranslations.continueBtnText || this.continueBtnText;
            this.forgotPassBtnText =
        loginTranslations.forgotPassBtnText || this.forgotPassBtnText;
            this.resetFormSuccessMsg =
        loginTranslations.resetFormSuccessMsg || this.resetFormSuccessMsg;
            this.forgotPassConfirmBtnText =
        loginTranslations.forgotPassConfirmBtnText ||
        this.forgotPassConfirmBtnText;
            this.forgotPassConfirmText =
        loginTranslations.forgotPassConfirmText || this.forgotPassConfirmText;
            this.forgotPassConfirmTitle =
        loginTranslations.forgotPassConfirmTitle || this.forgotPassConfirmTitle;
            this.forgotPassError =
        loginTranslations.forgotPassError || this.forgotPassError;
            this.loginTokenBtnText =
        loginTranslations.loginTokenBtnText || this.loginTokenBtnText;
            this.loginTokenConfirmText =
        loginTranslations.loginTokenConfirmText || this.loginTokenConfirmText;
            this.loginTokenConfirmTitle =
        loginTranslations.loginTokenConfirmTitle || this.loginTokenConfirmTitle;
            this.loginTokenLabel =
        loginTranslations.loginTokenLabel || this.loginTokenLabel;
            this.loginTokenTagline =
        loginTranslations.loginTokenTagline || this.loginTokenTagline;
            this.loginTokenTitle =
        loginTranslations.loginTokenTitle || this.loginTokenTitle;
            this.forgotPassLabel =
        loginTranslations.forgotPassLabel || this.forgotPassLabel;
            this.forgotPassLinkText =
        loginTranslations.forgotPassLinkText || this.forgotPassLinkText;
            this.forgotPassTagline =
        loginTranslations.forgotPassTagline || this.forgotPassTagline;
            this.forgotPassTitle =
        loginTranslations.forgotPassTitle || this.forgotPassTitle;
            this.loginFormErrorMsg =
        loginTranslations.loginFormErrorMsg || this.loginFormErrorMsg;
            this.loginPasswordError =
        loginTranslations.loginPasswordError || this.loginPasswordError;
            this.loginUsernameError =
        loginTranslations.loginUsernameError || this.loginUsernameError;
            this.pageTitle = loginTranslations.pageTitle || this.pageTitle;
            this.passwordLabel =
        loginTranslations.passwordLabel || this.passwordLabel;
            this.logInBtnText = loginTranslations.logInBtnText || this.logInBtnText;
            this.signUpBtnText =
        loginTranslations.signUpBtnText || this.signUpBtnText;
            this.signUpMarketingBenefits1 =
        loginTranslations.signUpMarketingBenefits1 ||
        this.signUpMarketingBenefits1;
            this.signUpMarketingBenefits2 =
        loginTranslations.signUpMarketingBenefits2 ||
        this.signUpMarketingBenefits2;
            this.signUpMarketingBenefits3 =
        loginTranslations.signUpMarketingBenefits3 ||
        this.signUpMarketingBenefits3;
            this.signUpMarketingBenefits4 =
        loginTranslations.signUpMarketingBenefits4 ||
        this.signUpMarketingBenefits4;
            this.signUpMarketingTagline =
        loginTranslations.signUpMarketingTagline || this.signUpMarketingTagline;
            this.signUpMarketingTitle =
        loginTranslations.signUpMarketingTitle || this.signUpMarketingTitle;
            this.usernameLabel =
        loginTranslations.usernameLabel || this.usernameLabel;
            this.welcomeText = loginTranslations.welcomeText || this.welcomeText;
            this.passwordShowText =
        loginTranslations.passwordShowText || this.passwordShowText;
            this.passwordHideText =
        loginTranslations.passwordHideText || this.passwordHideText;
            this.marketingBenefits.push({text: this.signUpMarketingBenefits1});
            this.marketingBenefits.push({text: this.signUpMarketingBenefits2});
            this.marketingBenefits.push({text: this.signUpMarketingBenefits3});
            this.marketingBenefits.push({text: this.signUpMarketingBenefits4});
            this.hidePasswordText = this.passwordShowText;
        },
        _getClientId: () =>{
            const config = ConfigService.getMarketConfig() || {};

            return (config.checkout || {}).clientId;
        }
    }
};
</script>

<style lang="scss">
@use "sass:map";
@import "~@nuskin/ns-core-styles/src/scss/global.mixins";
@import "~@nuskin/ns-core-styles/src/scss/typographyVariables";
@import "~@nuskin/ns-core-styles/src/scss/forms";
@import "~@nuskin/ns-core-styles/src/scss/buttons";
@import "~@nuskin/ns-core-styles/src/scss/vuetifyOverrides";
@import "~@nuskin/ns-core-styles/src/scss/colors";

ul {
  list-style: none; /* Remove default bullets */
}

ul li::before {
  content: "\2022"; /* Add content: \2022 is the CSS Code/unicode for a bullet */
  color: black; /* Change the color */
  font-weight: bold; /* If you want it to be bold */
  display: inline-block; /* Needed to add space between the bullet and the text */
  width: 1em; /* Also needed for space (tweak if needed) */
  margin-left: -1em; /* Also needed for space (tweak if needed) */
}

.v-input__icon.v-input__icon--append {
  -webkit-box-flex: 1;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: unset;
  height: unset;
}

.member-signup {
  section {
    h2 {
      font-size: 32px;
      font-weight: 100;
    }

    .description {
      text-align: left;
      margin-top: 15px;
    }
  }

  .section-title {
    text-transform: uppercase;
    text-align: left;
    font-size: 16px;
    margin-bottom: 15px;
  }

  .optin-options {
    // margin-left: 40px;
    // margin-bottom: 40px;
    .v-input--checkbox {
      height: 40px;
    }
  }

  .sms-terms {
    text-align: left;
    margin-left: 30px;
    margin-bottom: 15px;
  }

  .termslinks {
    text-align: left;
    margin: -15px 0 20px 38px;
  }

  .login-button {
    margin-top: -15px;
  }

  * {
    box-sizing: border-box;
  }

  h2 {
    margin-bottom: 10px;
  }

  .subtitle {
    @include subtitle();
  }

  section {
    max-width: 400px;
    margin: 0 auto 30px auto;
    // transition: all 1s ease-in-out;
  }

  .signin-link {
    border-bottom: 1px solid map-get($baseColors, ash);
    padding: 20px 0;
  }

  p {
    @include p-medium();
    margin-bottom: 0;
  }

  a {
    @include a-base();
    color: map-get($themeColors, color-expressive-6);
    text-decoration: none;

    &:hover {
      color: map-get($themeColors, color-interactive-3);
    }
  }

  .v-input div a {
    font-size: 16px;
  }

  .v-label div,
  .v-label div p {
    color: map-get($baseColors, blackhole);
    font-weight: map.get($typography, font-weight-normal);
  }

  .unknown-error {
    padding-top: 15px;
  }

  @media screen and (max-width: 480px) {
    padding: 20px;
  }

    .captcha-styles {
        margin-bottom: 1em;
    }

  .forgot-pass-link {
    display: flex;
    margin-top: -10px;
    margin-bottom: 25px;
  }

  #signupMarketing .benefits {
    max-width: 400px;
    padding: 20px 0 60px;
    margin: 0 auto;
    background-color: white;
  }

  #signupMarketing .benefits li {
    text-align: left;
    padding-left: 25px;
    padding-bottom: 7px;
  }
}

@media (min-width: 768px) {
  hr.loginline {
    margin-left: -70px;
    margin-right: -70px;
    border-top: 1px solid #000;
    text-align: center;
  }
}

@media (max-width: 768px) {
  hr.loginline {
    border-top: 1px solid #000;
    text-align: center;
  }
}

@media screen and (max-width: 768px) {
  section {
    max-width: 100%;
    padding: 20px 20px 0px;
    padding-top: 20px;
    padding-right: 20px;
    padding-bottom: 0px;
    padding-left: 20px;
  }
}

@media screen and (max-width: 768px) {
  .member-signup section {
    max-width: 400px;
    margin: 0 auto -10px auto;
  }
}

@media (min-width: 768px) {
  .member-signup section {
    max-width: 400px;
    margin: 50px auto 30px auto;
  }
}

#loginFormError {
  text-align-last: left;
  padding-bottom: 20px;
}

#loginFormError p {
  color: #b2140a;
}

#forgotPasswordAnchor {
  text-decoration: underline;
  margin-top: 8px;
  margin-bottom: 10px;
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: 14px;
  letter-spacing: 0.6px;
  line-height: 17px;
  font-family: var(--a-base_-_font-family, var(--font-family-primary));
  font-weight: var(--a-base_-_font-weight, var(--font-weight-semibold));
  font-size: var(--a-base_-_font-size, 14px);
  letter-spacing: var(--a-base_-_letter-spacing, 0.6px);
  line-height: var(--a-base_-_line-height, 17px);
  font-weight: normal;
  color: var(--color-primary-text);
  color: var(--color-primary-text);
}
</style>
